{
  "it": {
    "todo": {
      "actions": {
        "add": "Aggiungi attività",
        "cancel": "Annulla",
        "delete_todo": "Elimina attività",
        "edit": "Modifica attività",
        "save": "Salva"
      },
      "attributes": {
        "active": "Attiva",
        "assignee": "Responsabile",
        "completed": "Completata",
        "description": "Descrizione",
        "due_date": "Scadenza",
        "title": "Titolo"
      },
      "labels": {
        "active": "attiva",
        "allDone": "Tutte le attività sono state completate.",
        "allTodos": "Tutte le attività",
        "completed": "completata",
        "filterTodos": "Filtra attività",
        "filters": "Filtri",
        "myTodos": "Le mie attività",
        "myTodosCount": "Le mie attività ({count})",
        "noActiveTodos": "Nessuna attività attiva",
        "noActiveTodosDashboard": "Complimenti, non ha attività aperte.",
        "noCompletedYet": "Ancora nessuna attività completata.",
        "noTodosCustomer": "Ottimo, non ha attività aperte.",
        "selectAProjectFirst": "Selezioni prima un progetto",
        "showLess": "Mostra meno",
        "showOthers": "Mostra altro | Mostra altro ({count})"
      },
      "toasts": {
        "create": "Attività creata",
        "delete": "Attività eliminata",
        "update": "Attività aggiornata"
      },
      "validation": {
        "needtitle": "Il titolo è obbligatorio"
      }
    }
  }
}
